import { useEffect } from 'react'

// useContainerSize.js
// this hook is used to set the size of a container element based on the size of the parent container
// the options are:
// - scale: the scale of the container element
// - minSize: the minimum size of the container element
// - maxSize: the maximum size of the container element
// - cssVar: the css variable to set the size of the container element
// - target: the target element to set the size of

export const useContainerSize = (containerRef, options = {}) => {
  const {
    scale = 0.9,
    minSize = 32,
    maxSize = 90,
    cssVar = '--btn-size',
    target = 'button',
  } = options

  useEffect(() => {
    // console.log('userContainerSize called: ')

    if (!containerRef.current) return

    // console.log('container: ', containerRef)

    const observers = []

    const container = containerRef.current
    const targetElement = container.querySelector(target) || container

    const ro = new ResizeObserver(() => {
      const cs = getComputedStyle(container)
      const width =
        container.clientWidth -
        (parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight))
      const height =
        container.clientHeight -
        (parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom))

      // console.log('Container dimensions:', {
      //   width,
      //   height,
      //   container: container.className,
      // })

      const limitingSide = Math.max(0, Math.min(width, height))
      const clamped = Math.max(minSize, Math.min(limitingSide, maxSize)) * scale

      // console.log('targetElement: ', targetElement)
      // console.log('limitingSide: ', limitingSide)
      const next = `${clamped}px`
      if (targetElement.style.getPropertyValue(cssVar) !== next) {
        targetElement.style.setProperty(cssVar, next)
      }
    })

    ro.observe(container)
    observers.push(ro)

    return () => observers.forEach((ro) => ro.disconnect())
  }, [containerRef, scale, minSize, maxSize, cssVar, target])
}
